import { render } from "./TheBooks.vue?vue&type=template&id=4806f8f6&scoped=true"
import script from "./TheBooks.vue?vue&type=script&lang=js"
export * from "./TheBooks.vue?vue&type=script&lang=js"

import "./TheBooks.vue?vue&type=style&index=0&id=4806f8f6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4806f8f6"]])

export default __exports__